import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { size } from 'lodash';
import { getEmailBranding } from 'apollo/notes.query';
import './styles.scss';

const EmailPreviewForm = ({ formData, onBack }) => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const [brandLogo, setBrandLogo] = useState(null);
  const [emailFooter, setEmailFooter] = useState(['', '']);

  const {
    subject,
    message,
    primaryEmail,
    bcc,
    bccSender,
  } = formData || {};
  const email = bccSender && size(bcc) ? `${primaryEmail}, ${bcc?.join(', ')}` : primaryEmail;
  const { firstName, lastName, orgId } = userInfo;

  // #TODO: Lift branding logic/tempalte into separate component.
  const getBrandingInfo = async () => {
    const response =  await getEmailBranding(orgId);
    if (response?.data?.emailBranding[0]) {
      const { logo, templateDict } = response.data.emailBranding[0];
      const logoPath = logo?.resolutions?.full?.path;
      if (logoPath) {
        setBrandLogo(`//${process.env.REACT_APP_AWS_CLOUDFRONT}/${logoPath}`);
      }
      setEmailFooter(templateDict ? Object.values(templateDict) : ['', '']);
    }
  };

  useEffect(() => {
    getBrandingInfo();
  }, []);

  return (
    <section className="email_previewer">
      <aside className="email_previewer__header">
        <p
          className="email_title"
          title={userInfo?.email}
        >
          From: {`${firstName} ${lastName}`}
        </p>
        <p className="email_address">To: {email}</p>
        <p className="email_subject">Subject: {subject}</p>
      </aside>
      <section className="email_previewer__content">
        {brandLogo && (
          <section className="email_previewer__content_header">
            <img
              className="logo"
              src={brandLogo}
              alt="logo"
            />
          </section>
        )}
        <article className="email_previewer__content_description">
          <div // TODO: This is a placeholder
            className="message_preview"
          >
            {message}
          </div>
          <br />
          <section
            className={clsx('gold', 'view-document')}
            disabled
          >
            See Details
          </section>
        </article>
        <section className="email_previewer__content_footer">
          {!!emailFooter[0] && <p>{emailFooter[0]}</p>}
          {!!emailFooter[1] && <span>{emailFooter[1]}</span>}
        </section>
      </section>
      <div className="share-form__buttons">
        <button
          type="button"
          className="button"
          onClick={onBack}
        >
          Back To Editor
        </button>
      </div>
    </section>
  );
};

EmailPreviewForm.propTypes = {
  formData: PropTypes.object,
  onBack: PropTypes.func,
};

EmailPreviewForm.defaultProps = {};

export default EmailPreviewForm;
